import type { AboutAIMessage } from '../../types/messageTypes'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import styles from './AboutAIResponse.module.scss'

interface AboutAIResponseProps {
	readonly message: AboutAIMessage
}

export function AboutAIResponse({ message }: AboutAIResponseProps) {
	const { t } = useLabels()

	return (
		<div className={styles.aboutAIResponse}>
			<p>{t(message.value)}</p>
			<ul>
				{message.disclaimers.map((disclaimer) => (
					<li key={disclaimer}>
						<ClientLabel>{t(disclaimer)}</ClientLabel>
					</li>
				))}
			</ul>
		</div>
	)
}
